import { useMemo } from 'preact/hooks';
import type { ReturnCountry } from 'interfaces/WidgetConfigs.interface';
import countryMaps from '@pperform/pp-constants/countryCode';
import { getCountryOptions } from './SearchDropOff.utils';

export const useCountryOptions = (
  returnCountry: ReturnCountry,
  t: (key: string) => string,
) => {
  const { isSpecificCountriesEnabled, specificCountries } = returnCountry;

  return useMemo(() => {
    const options = isSpecificCountriesEnabled
      ? countryMaps.filter((item) =>
          specificCountries?.includes(item.country_code),
        )
      : countryMaps;
    return getCountryOptions(t, options);
  }, [isSpecificCountriesEnabled, specificCountries]);
};
